module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "corporateSponsors"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v("Corporate Sponsors")]), _vm._v(" "), _vm._l((_vm.sponsors), function(sponsor) {
    return _c('div', {
      staticClass: "sponsor"
    }, [_c('div', {
      staticClass: "logo"
    }, [_c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": sponsor.logo.sizes.medium
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('h5', {
      domProps: {
        "innerHTML": _vm._s(sponsor.name)
      }
    }), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(sponsor.description)
      }
    })])])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8d12bf60!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OurTeam/CorporateSponsors.vue
// module id = 400
// module chunks = 2